module.exports = __webpack_public_path__ + "fonts/fa-regular-400.54f142e0.ttf";